import { useMemo } from 'react';

function useHistogram({ data }) {
  const maxRange = Math.max(...(data || [0]));
  if (!maxRange || maxRange <= 0) return { modifiedBarData: {} };

  // Ensure divisionFactor is never less than 1
  const divisionFactor = Math.max(1, 10 ** (Math.floor(Math.log10(maxRange)) - 1));
  const graphSegmentLength = Math.ceil(maxRange / divisionFactor);

  const modifiedBarData = useMemo(() => {
    const modifiedData = {};
    let value = 0;

    for (let i = 0; i < graphSegmentLength; i++) {
      const prevVal = value;
      value += divisionFactor;
      const upper = Math.round(value); // ensure integers
      modifiedData[upper] = 0;

      (data || []).forEach((elem) => {
        if (elem > prevVal && elem <= upper) {
          modifiedData[upper]++;
        }
      });
    }

    return modifiedData;
  }, [data, divisionFactor, graphSegmentLength]);

  return { modifiedBarData };
}

export default useHistogram;
